import type { FunctionComponent } from "react";
import { PostStatus } from "../../../types/models/post.models.types";
import { useParams } from "react-router-dom";
import CampaignPostsBrandPartial from "../../../partials/brand/home/campaign-posts/campaign-posts.brand.partials";

export const CampaignLivePostsBrandScreen: FunctionComponent = () => {
	const { campaignId } = useParams();

	if (!campaignId) {
		throw new Error("campaign id not found");
	}

	return (
		<CampaignPostsBrandPartial
				tabs={[
				{
					status: PostStatus.postApproved,
					title: "Live Posts",
					flagged: false,
				},
			]}
			initialStatus={PostStatus.postApproved}
			campaignId={campaignId}
		/>
	);
};
